<crud-list class="col-12" [data]="table" detailUrl="/enaio-learn/admin/external-user/" restUrl="api/lrn/externalUser">
</crud-list>
